/* app/js/src/components/external-mam/external-mam-gateway-playground/external-mam-gateway-playground.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  padding: 25px;
  width: 100vw;
  height: 90vh;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 50px;
}
.search-container {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 20px;
}
.search-container .buttons {
  display: flex;
  align-items: center;
  align-self: stretch;
  text-align: center;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Open Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  gap: 20px;
}
.search-container .buttons button {
  display: flex;
  padding: 9px 16px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 4px;
  outline: none;
  cursor: pointer;
  text-transform: uppercase;
}
.search-container .buttons button.clear {
  color: rgba(0, 0, 0, 0.54);
  background-color: transparent;
}
.search-container .buttons button.search {
  background: #2dbbfc;
  color: #ffffff;
  border-color: #2dbbfc;
}
.search-results {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 4px;
  height: calc(65vh - 30px);
  background: #ffffff;
}
::ng-deep .import-button {
  cursor: not-allowed;
  background: rgba(0, 0, 0, 0.2);
}
::ng-deep .import-button svg path {
  fill: black;
  fill-opacity: 0.35;
}
::ng-deep .import-button.active {
  cursor: pointer;
  background: rgb(45, 187, 252);
  color: #ffffff;
}
::ng-deep .import-button.active svg path {
  fill: #ffffff;
  fill-opacity: 1;
}
::ng-deep .external-mam-search-results-default-cell-class {
  color: rgba(0, 0, 0, 0.85);
  font-feature-settings: "clig" off, "liga" off;
  font-family: Open Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal !important;
  padding: 15px 15px 15px 20px;
}
/*# sourceMappingURL=external-mam-gateway-playground.component.css.map */
